import React from 'react';

const HERO_IMAGE = {
    url: "/images/wayside-hero.png",
    alt: "Pure Pennsylvania Maple Syrup bottle with breakfast spread"
};

const HeroCarousel = () => {
    return (
        <section className="relative min-h-[100svh] md:h-screen w-full overflow-hidden" data-testid="hero-carousel">
            <div className="absolute inset-0">
                <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/55 to-black/70 z-10" />
                <img
                    src={HERO_IMAGE.url}
                    alt={HERO_IMAGE.alt}
                    className="w-full h-full object-cover"
                />
            </div>

            {/* Content */}
            <div className="relative z-20 h-full flex items-center py-28 sm:py-32 md:py-0">
                <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 w-full">
                    <div className="max-w-3xl">
                        <span className="text-maple-red font-mono text-xs sm:text-sm tracking-[0.25em] mb-4 block animate-fade-in-up">
                            WAYSIDE MAPLE
                        </span>
                        <h1 
                            className="font-anton text-[2.75rem] sm:text-7xl lg:text-8xl text-white leading-[0.92] animate-fade-in-up max-w-[10ch]"
                            style={{ animationDelay: '0.1s' }}
                        >
                            FROM THE HILLS OF
                        </h1>
                        <h2 
                            className="font-anton text-3xl sm:text-5xl lg:text-6xl text-white/80 mt-3 animate-fade-in-up max-w-[12ch]"
                            style={{ animationDelay: '0.2s' }}
                        >
                            TROY, PENNSYLVANIA
                        </h2>
                        <p 
                            className="text-white/85 text-base sm:text-lg mt-6 sm:mt-8 max-w-md sm:max-w-lg leading-relaxed animate-fade-in-up"
                            style={{ animationDelay: '0.3s' }}
                        >
                            Premium small-batch maple syrup, crafted with tradition 
                            and care in the hills of Pennsylvania.
                        </p>
                        <div 
                            className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-8 sm:mt-10 animate-fade-in-up max-w-sm"
                            style={{ animationDelay: '0.4s' }}
                        >
                            <a href="/shop" className="btn-primary" data-testid="hero-shop-btn">
                                <span>Shop Now</span>
                            </a>
                            <a href="/about" className="btn-secondary-light" data-testid="hero-about-btn">
                                Our Story
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Scroll indicator */}
            <div className="absolute bottom-12 right-12 z-30 hidden md:block">
                <div className="flex flex-col items-center gap-2 text-white/40">
                    <span className="font-mono text-xs tracking-widest rotate-90 origin-center translate-y-8">
                        SCROLL
                    </span>
                    <div className="w-px h-16 bg-white/20 mt-8" />
                </div>
            </div>
        </section>
    );
};

export default HeroCarousel;
